function EducationItem({ degree, institution, period }) {
  return (
    <div className="bg-surface-card p-5 sm:p-6 rounded-xl border border-surface-border transition-colors hover:border-accent-violet/40">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
        <div>
          <h3 className="text-lg font-semibold sm:text-xl">{degree}</h3>
          <p className="text-gray-400">{institution}</p>
        </div>
        <p className="text-sm text-accent-cyan shrink-0">{period}</p>
      </div>
    </div>
  );
}

export default function Education() {
  return (
    <section className="border-t border-surface-border px-5 py-14 sm:px-12 sm:py-20">
      <h2 className="text-3xl font-bold mb-2 sm:text-4xl sm:mb-3">
        <span className="text-gradient">Education</span>
      </h2>
      <p className="text-gray-400 mb-8 sm:mb-10 text-sm sm:text-base">Academic background</p>
      <div className="space-y-4 sm:space-y-5">
        <EducationItem
          degree="Master of Computer Applications (MCA)"
          institution="PES University, Bengaluru"
          period="2022 — 2024"
        />
        <EducationItem
          degree="Bachelor of Business Administration (BBA)"
          institution="Jain College, Belgaum"
          period="2019 — 2022"
        />
      </div>
    </section>
  );
}
